import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticDevelop = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findDevelopSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useDevelopQuery {
		squidex {
			findDevelopSingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					backgroundImageFocusAreas {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(layout: FULL_WIDTH, quality: 100)
								}
							}
							...SquidexLocalFileProps
						}
					}

					map {
						de {
							title
							text
							filterTitle
						}
					}
				}
			}
		}
	}
`;
